import { useState } from "react";
import {ReactComponent as DownArrow} from '../../assets/image/icons/down-arrow.svg';
export const CollapseExpand = ({title, expanded, children}) => {
    const [isCollapsed, setCollapsed] = useState(!expanded);
    const handleToggle = () => {
        setCollapsed(!isCollapsed);
    };
    return (
        <div>
            <div className="flex flex-row text-white text-[15px] leading-7 px-[30px] py-[15px] justify-between" onClick={handleToggle}>
                {title}
                {isCollapsed ? <DownArrow className="w-[30px] h-[30px]"/> : <DownArrow className="w-[30px] h-[30px] rotate-[180]"/>}
            </div>
            {!isCollapsed && (
                <div>{children}</div>
            )}
        </div>
    );
}